import { motion } from "framer-motion";
import React from "react";

const EASE = [0.16, 1, 0.3, 1];

// Splits a string into words and reveals each on its own masked line.
export function MaskedReveal({
  text,
  as: Tag = "h1",
  className = "",
  delay = 0,
  stagger = 0.06,
  duration = 1,
  once = true,
  testId,
  animate = false, // when true, plays immediately on mount instead of waiting for in-view
}) {
  const words = text.split(" ");
  const revealProps = animate
    ? { initial: { y: "110%" }, animate: { y: "0%" } }
    : { initial: { y: "110%" }, whileInView: { y: "0%" }, viewport: { once, margin: "-10%" } };
  return (
    <Tag className={className} data-testid={testId} aria-label={text}>
      {words.map((w, i) => (
        <span key={i} className="line-mask inline-block align-bottom" aria-hidden>
          <motion.span
            {...revealProps}
            transition={{
              duration,
              ease: EASE,
              delay: delay + i * stagger,
            }}
            className="inline-block will-change-transform"
          >
            {w}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, y = 30, className = "", duration = 1 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration, ease: EASE, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return <div className={`overline text-ink/60 ${className}`}>{children}</div>;
}

export function SectionLabel({ number, label }) {
  return (
    <div className="flex items-center gap-4">
      <span className="overline text-ink/50">{number}</span>
      <span className="h-px w-14 bg-ink/20" />
      <span className="overline text-ink">{label}</span>
    </div>
  );
}

export const EASE_OUT = EASE;
